import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EnvelopeRepositoryService } from '../../services/envelopes/envelope-repository.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Envelope } from '../../interfaces/envelopes/envelope';
import { FiltersComponent } from '../filters-component';
import { HttpParams } from '@angular/common/http';
import { eEnvelopeType } from '../../enums';

@Component({
  selector: 'lib-hub-reports-filter',
  templateUrl: './hub-reports-filter.component.html',
  styleUrl: './hub-reports-filter.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HubReportsFilterComponent extends FiltersComponent<Envelope> implements OnInit, OnDestroy {

  constructor(
    envelopesService: EnvelopeRepositoryService,
    formBuilder: FormBuilder,
    datePipe: DatePipe) {
    super(envelopesService, formBuilder, datePipe);
  }

  ngOnInit(): void {
    this._filterForm = this.formBuilder.group({
      businessName: [null],
      businessNumber: [null],
      orderReference: [null],
      envelopeStatusUpdatedDateTo: [null],
      envelopeStatusUpdatedDateFrom: [null]
    });

    this._defaultParams = this.buildParamsFromForm(this._filterForm);
    let params = new HttpParams()
      .append('EnvelopeType', eEnvelopeType.hubReport);
    this.repo.getFirstPage(params);
  }

  ngOnDestroy(): void {
    this.repo.clearFilters();
  }

  protected handleJurisdictionFormReady(event: FormGroup) {
    this._filterForm.setControl('country', event);
  }
}
